import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { filter, map, tap } from 'rxjs/operators';
import { UntilDestroy } from '@ngneat/until-destroy';
import { merge, of, shareReplay, switchMap } from 'rxjs';
import { BazisConfigurationService, SHARE_REPLAY_SETTINGS } from '@bazis/configuration.service';
import { BazisEntityService } from '@bazis/shared/services/entity.service';
import { BazisInputHintComponent } from '@bazis/form/components/base/hint/input-hint.component';
import { BazisSrvService } from '@bazis/shared/services/srv.service';

@UntilDestroy()
@Component({
    selector: 'bazis-input-tin',
    templateUrl: './input-tin.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisInputTinComponent extends BazisInputHintComponent {
    @Input()
    selectObject: boolean = false;

    @Input()
    placeholderListKey: string;

    constructor(
        @Self() public ngControl: NgControl,
        protected cdr: ChangeDetectorRef,
        public configurationService: BazisConfigurationService,
        protected entityService: BazisEntityService,
        protected srv: BazisSrvService,
    ) {
        super(ngControl, cdr, configurationService, entityService);
    }

    listFromAddress$ = this.searchControl.valueChanges.pipe(
        filter((v) => !!v),
        switchMap((value) => {
            return value
                ? this.srv.commonGetRequest$('dadata/suggest_organization', { data: value })
                : of([]);
        }),
        shareReplay(SHARE_REPLAY_SETTINGS),
    );

    list$ = merge(this.listFromAddress$).pipe(
        map((list) =>
            list.map((item) => {
                return {
                    ...item.data,
                    name: item.value,
                };
            }),
        ),
        tap((v) => {
            this.showList = true;
        }),
        shareReplay(SHARE_REPLAY_SETTINGS),
    );

    selectValue(value: any) {
        if (this.selectObject) {
            this.searchControl.setValue(value.inn + ' ' + value.name, { emitEvent: false });
            this.onChange(value);
        } else {
            this.searchControl.setValue(value.inn, { emitEvent: false });
            this.onChange(value.inn);
        }

        this.hideList();
    }
}
